import React from 'react';
import { Cog6ToothIcon, XMarkIcon } from '@heroicons/react/24/outline';
import usePlayerStore from '../../stores/playerStore';

const SettingsModal = ({ isOpen, onClose }) => {
  const {
    volume,
    setVolume,
  } = usePlayerStore();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-gray-900 rounded-xl border border-white/10 p-6 max-w-md w-full mx-4 shadow-2xl">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold text-white flex items-center gap-2">
            <Cog6ToothIcon className="w-6 h-6" />
            Settings
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/10 rounded-full transition-colors"
            aria-label="Close settings"
          >
            <XMarkIcon className="w-6 h-6 text-white" />
          </button>
        </div>

        <div className="space-y-6">
          <div className="space-y-2">
            <label className="text-white/80 text-sm">Volume</label>
            <div className="flex items-center gap-4">
              <input
                type="range"
                min="0"
                max="100"
                value={volume}
                onChange={(e) => setVolume(parseInt(e.target.value, 10))}
                className="flex-1"
                aria-label="Volume"
              />
              <span className="text-white/60 w-12 text-right">{volume}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsModal;
